import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { MainLayout } from './MainLayout'

ReactDOM.render(<MainLayout />, document.getElementById('root'))
